module.exports = __webpack_public_path__ + "img/header-image.2119cb39.png";